/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  Column,
  ContextMenu,
  Row,
  Text,
  TEXT_VARIANTS,
  Icon,
  IconNames,
} from "../..";

// TODO: move to theme
const COLORS = {
  GREEN: "#00FF38",
  LIME: "#e2fea4",
  LIGHT: "#f6f6f9",
  SILVER: "#949CA6",
  BLUE: "#0075FF",
  BLACK: "#000",
  NUMBER: "#C3C9D0",
  WHITE: "#fff",
} as const;

// TODO: extract to component
const ListItem: React.FC<{
  icon?: JSX.Element;
  label: string;
  active?: boolean;
  textVariant?: TEXT_VARIANTS;
  textColor?: typeof COLORS[keyof typeof COLORS];
}> = ({
  icon: Icon,
  label,
  active = false,
  textVariant = TEXT_VARIANTS.T20,
  textColor = COLORS.BLACK,
}) => (
  <Row
    role="button"
    gap={10}
    crossAxisAlignment="center"
    css={css`
      transition: all 120ms ease;
      cursor: pointer;
      height: 35px;
      padding: 0 ${Icon !== undefined ? 5 : 10}px;
      border-radius: 10px;
      color: ${textColor};
      background-color: ${active ? COLORS.LIME : "transparent"};

      &:hover {
        background-color: ${active ? COLORS.LIME : COLORS.LIGHT};
      }
    `}
  >
    {Icon !== undefined && Icon}
    <Text variant={textVariant}>{label}</Text>
  </Row>
);

export const FeedCard: React.FC<React.PropsWithChildren<{ path: string }>> = ({
  path,
  children,
}) => (
  <Card
    css={css`
      transition: all 120ms ease;
      cursor: pointer;
      padding: 10px;
      border: none;
      box-shadow: 0 0.1rem 0.5rem rgb(0 0 0 / 10%);

      &:hover {
        box-shadow: 0 0.5rem 1.5rem rgb(0 0 0 / 10%);
      }

      &:hover .feed-card__footer__connections {
        color: ${COLORS.GREEN};
      }
    `}
  >
    <Link
      to={path}
      css={css`
        text-decoration: none;
        color: inherit;
      `}
    >
      <Column gap={5}>
        {children}
        <Row crossAxisAlignment="center" mainAxisAlignment="space-between">
          <Text
            className="feed-card__footer__connections"
            role="button"
            variant={TEXT_VARIANTS.T30SOFT}
            css={css`
              transition: all 120ms ease;
              cursor: pointer;
              color: ${COLORS.NUMBER};
            `}
          >
            {8}
          </Text>
          <Row gap={5}>
            <ContextMenu
              renderElement={(toggleOpen) => (
                <Button
                  leadingElement={() => <Icon name={IconNames.More} />}
                  onClick={toggleOpen}
                />
              )}
              renderMenu={() => (
                <Column
                  gap={5}
                  css={css`
                    width: 250px;
                    padding: 5px;
                  `}
                >
                  <ListItem
                    icon={<Icon name={IconNames.Edit} />}
                    label="Edit"
                  />
                  <ListItem
                    icon={<Icon name={IconNames.Share} />}
                    label="Copy link"
                  />
                  <ListItem
                    icon={<Icon name={IconNames.Pinned} />}
                    label="Pin"
                  />
                  <ListItem
                    icon={<Icon name={IconNames.Unpin} />}
                    label="Unnpin"
                  />
                  <ListItem
                    icon={<Icon name={IconNames.Favorites} />}
                    label="Favorite"
                  />
                  <ListItem
                    icon={<Icon name={IconNames.Unfavorite} />}
                    label="Unfavorite"
                  />
                  <ListItem
                    icon={<Icon name={IconNames.Disconnect} />}
                    label="Remove connection"
                  />
                  <ListItem
                    icon={<Icon name={IconNames.Delete} />}
                    label="Delete"
                  />
                </Column>
              )}
            />
            <Button leadingElement={() => <Icon name={IconNames.Share} />} />
            <Button
              label="Connect"
              trailingElement={() => <Icon name={IconNames.Connect} />}
            />
          </Row>
        </Row>
      </Column>
    </Link>
  </Card>
);
